const compareObjectsEqual = (object: unknown, reference: unknown) => {
  return JSON.stringify(object) === JSON.stringify(reference)
}

const compareObjectsDifferent = (object: unknown, reference: unknown) => {
  return !compareObjectsEqual(object, reference)
}

export { compareObjectsDifferent, compareObjectsEqual }
